import { render, staticRenderFns } from "./LightWidget.vue?vue&type=template&id=a416740a&scoped=true&"
import script from "./LightWidget.vue?vue&type=script&lang=js&"
export * from "./LightWidget.vue?vue&type=script&lang=js&"
import style0 from "./LightWidget.vue?vue&type=style&index=0&id=a416740a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a416740a",
  null
  
)

export default component.exports